import { StoreAction } from "../../@core/constants/action";

const initialState = {
  smsTemplateList: [],
  emailTemplateList: [],
  meetingTemplateList: [],
  whatsAppTemplateList: [],
  reminderTemplateList: [],
  birthTemplateList: [],
  leadTemplateList: [],
  celebrationTemplateList: [],
  invoiceTemplateList: [],
  hiringTemplateList: [],
  metaTemplateList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StoreAction.GET_EMAIL_TEMPLATES:
      return {
        ...state,
        emailTemplateList: action.payload,
      };
    case StoreAction.GET_SMS_TEMPLATE:
      return {
        ...state,
        smsTemplateList: action.payload,
      };
    case StoreAction.GET_WHATSAPP_TEMPLATE:
      return {
        ...state,
        whatsAppTemplateList: action.payload,
      };
    case StoreAction.GET_REMINDER_TEMPLATES:
      return {
        ...state,
        reminderTemplateList: action.payload,
      };
    case StoreAction.GET_MEETING_TEMPLATES:
      return {
        ...state,
        meetingTemplateList: action.payload,
      };
    case StoreAction.GET_BIRTH_TEMPLATES:
      return {
        ...state,
        birthTemplateList: action.payload,
      };
    case StoreAction.GET_LEAD_TEMPLATE:
      return {
        ...state,
        leadTemplateList: action.payload,
      };
    case StoreAction.GET_CELEBRATION_TEMPLATE:
      return {
        ...state,
        celebrationTemplateList: action.payload,
      };
    case StoreAction.GET_MEETING_TEMPLATE:
      return {
        ...state,
        meetingTemplateList: action.payload,
      };
    case StoreAction.GET_INVOICE_TEMPLATE:
      return {
        ...state,
        invoiceTemplateList: action.payload,
      };
    case StoreAction.GET_REMINDER_TEMPLATE:
      return {
        ...state,
        reminderTemplateList: action.payload,
      };
    case StoreAction.GET_HIRING_TEMPLATE:
      return {
        ...state,
        hiringTemplateList: action.payload,
      };
    case StoreAction.GET_META_TEMPLATE:
      return {
        ...state,
        metaTemplateList: action.payload,
      };
    default:
      return state;
  }
}
